import { MapContainer, Marker, TileLayer } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import "leaflet/dist/leaflet.css";
import { Icon, divIcon, point } from "leaflet";
import L from "leaflet";
import {
  Box,
  Container,
  Paper,
  Typography,
  useTheme,
  alpha,
} from "@mui/material";
import { useEffect, useState } from "react";
import "./Style/map.css";
import { t } from "i18next";

const MapLearn = () => {
  const theme = useTheme();
  const [mapReady, setMapReady] = useState(false);
  const markers = [{ id: 1, geocode: [54.5602466, -1.3070571] }];

  const customIcon = new Icon({
    iconUrl: require("./Image/marker-icon.png"),
    iconSize: [38, 38],
  });

  const createCustomClusterIcon = (cluster) => {
    return new divIcon({
      html: `<div style="
        height: 3rem;
        width: 3rem;
        border-radius: 50%;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        transform: translate(-25%, -25%);
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 900;
        font-size: 1.5rem;
        color: white;
        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
        border: 3px solid white;
      ">${cluster.getChildCount()}</div>`,
      className: "custom-marker-cluster",
      iconSize: point(33, 33, true),
    });
  };

  // Function to handle marker click and redirect to Google Maps
  const handleMarkerClick = (lat, lng) => {
    const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
    window.open(googleMapsUrl, "_blank"); // Open in a new tab
  };

  // Fix for Leaflet default icon issue and ensure map renders
  useEffect(() => {
    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });
    setMapReady(true);
  }, []);

  return (
    <Box
      sx={{
        background:
          "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
        py: { xs: 4, md: 6 },
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, md: 4 } }}>
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: 24, md: 32 },
            fontWeight: 700,
            mb: 3,
            textAlign: "center",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {t("FindUsOnMap")}
        </Typography>
        <Paper
          elevation={0}
          sx={{
            borderRadius: 4,
            overflow: "hidden",
            border: "1px solid",
            borderColor: alpha(theme.palette.primary.main, 0.2),
            boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
            height: { xs: 400, md: 600 },
            width: "100%",
            position: "relative",
            "& .leaflet-container": {
              height: "100%",
              width: "100%",
              borderRadius: 4,
              zIndex: 0,
            },
            "& .leaflet-popup-content-wrapper": {
              borderRadius: 2,
            },
          }}
        >
          {mapReady && (
            <MapContainer
              center={[54.5602466, -1.3070571]}
              zoom={13}
              style={{ height: "100%", width: "100%", zIndex: 0 }}
              scrollWheelZoom={true}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <MarkerClusterGroup
                chunkedLoading
                iconCreateFunction={createCustomClusterIcon}
              >
                {markers.map((marker) => (
                  <Marker
                    key={marker.id}
                    position={marker.geocode}
                    icon={customIcon}
                    eventHandlers={{
                      click: () =>
                        handleMarkerClick(marker.geocode[0], marker.geocode[1]),
                    }}
                  >
                    {/* <Popup>{marker.popUp}</Popup> */}
                  </Marker>
                ))}
              </MarkerClusterGroup>
            </MapContainer>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default MapLearn;
